// src/mocks/handlers/auth/index.ts

import { loginHandler } from './loginHandler';
import { tokenHandler } from './tokenHandler';
import { refreshTokenHandler } from './refreshTokenHandler';
import { passwordResetHandler } from './passwordResetHandler';
import { protectedEndpointHandler } from './protectedEndpointHandler';
import { otpHandler } from './otpHandler';
import { passwordChangeHandler } from './passwordChangeHandler';
import { logoutHandler } from './logoutHandler';

export const authHandlers = [
  loginHandler,
  tokenHandler,
  refreshTokenHandler,
  passwordResetHandler,
  protectedEndpointHandler,
  otpHandler,
  passwordChangeHandler,
  logoutHandler,
];
